import type { AppDispatch, RootState } from '../../stores/redux';
import {
  type SurveyCallDetails,
  setupPostCallSurvey,
} from './postCallSurvey.slice';
import { getApolloSessionDetails } from '../apolloSession/apolloSession.selectors';
import { Vendor, media } from '../../webrtc/media';
import { logger } from './logger';

export const promptPostCallSurvey = (
  dispatch: AppDispatch,
  getState: () => RootState,
): void => {
  const apolloSession = getApolloSessionDetails(getState());
  const { dbSessionId, sessionId } = apolloSession;
  const noSoundDetected = !media.hasAudioAccess;

  const callDetails = {
    dbSessionId,
    sessionId,
    noSoundDetected,
    vendor: Vendor.Vonage,
  };

  const checkPresence = (o: typeof callDetails): o is SurveyCallDetails =>
    Boolean(o.dbSessionId) && Boolean(o.sessionId);

  if (checkPresence(callDetails)) {
    dispatch(setupPostCallSurvey(callDetails));
  } else {
    logger.error('[postCallSurvey/prompt]', 'Failed to open', { callDetails });
  }
};
